<script lang="ts">
  import type { CvrCompanyRow } from "$lib/types/cvr-company-row";

  let {
    open = false,
    row = null as CvrCompanyRow | null,
    onClose = () => {}
  } = $props();

  const formatMs = (value: number | null) => value === null ? "-" : `${Math.round(value)} ms`;
  const formatNumber = (value: number | null) => value === null ? "-" : `${Math.round(value)}`;
  const formatCls = (value: number | null) => value === null ? "-" : value.toFixed(3);
</script>

{#if open && row}
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
    <div class="max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-md border bg-background p-4">
      <div class="mb-4 flex items-start justify-between gap-4">
        <div>
          <h3 class="text-lg font-semibold">Website stats</h3>
          <p class="text-sm text-muted-foreground">{row.name || row.cvrNumber}</p>
          <p class="text-sm text-muted-foreground">{row.website || "-"}</p>
        </div>
        <button class="rounded border px-2 py-1 text-sm" onclick={() => onClose()}>Close</button>
      </div>

      <div class="mb-4 grid grid-cols-2 gap-2 text-sm md:grid-cols-3">
        <div>Performance: <span class="font-medium">{formatNumber(row.desktopPerformanceScore)}</span></div>
        <div>Accessibility: <span class="font-medium">{formatNumber(row.desktopAccessibilityScore)}</span></div>
        <div>Best Practices: <span class="font-medium">{formatNumber(row.desktopBestPracticesScore)}</span></div>
        <div>SEO: <span class="font-medium">{formatNumber(row.desktopSeoScore)}</span></div>
        <div>Speed Index: <span class="font-medium">{formatMs(row.desktopSpeedIndexMs)}</span></div>
        <div>FCP: <span class="font-medium">{formatMs(row.desktopFirstContentfulPaintMs)}</span></div>
        <div>LCP: <span class="font-medium">{formatMs(row.desktopLargestContentfulPaintMs)}</span></div>
        <div>TBT: <span class="font-medium">{formatMs(row.desktopTotalBlockingTimeMs)}</span></div>
        <div>CLS: <span class="font-medium">{formatCls(row.desktopCumulativeLayoutShift)}</span></div>
        <div>Status: <span class="font-medium">{row.desktopStatus || "-"}</span></div>
      </div>

      {#if row.desktopErrorMessage}
        <div class="mb-4 rounded border border-destructive/30 bg-destructive/10 p-3 text-sm">
          {row.desktopErrorMessage}
        </div>
      {/if}

      {#if row.desktopScreenshotDataUrl}
        <img
          src={row.desktopScreenshotDataUrl}
          alt="Website screenshot"
          class="h-auto w-full rounded border"
        />
      {:else}
        <p class="text-sm text-muted-foreground">No screenshot available.</p>
      {/if}
    </div>
  </div>
{/if}
